/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadAssignmentRole } from './LeadAssignmentRole';
import {
    LeadAssignmentRoleFromJSON,
    LeadAssignmentRoleFromJSONTyped,
    LeadAssignmentRoleToJSON,
} from './LeadAssignmentRole';

/**
 * 
 * @export
 * @interface LeadAssignment
 */
export interface LeadAssignment {
    /**
     * 
     * @type {string}
     * @memberof LeadAssignment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAssignment
     */
    screener_lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAssignment
     */
    user_id: string;
    /**
     * 
     * @type {LeadAssignmentRole}
     * @memberof LeadAssignment
     */
    role: LeadAssignmentRole;
    /**
     * 
     * @type {string}
     * @memberof LeadAssignment
     */
    assigned_by_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAssignment
     */
    assigned_via: string;
}

/**
 * Check if a given object implements the LeadAssignment interface.
 */
export function instanceOfLeadAssignment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "screener_lead_id" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "assigned_via" in value;

    return isInstance;
}

export function LeadAssignmentFromJSON(json: any): LeadAssignment {
    return LeadAssignmentFromJSONTyped(json, false);
}

export function LeadAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAssignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'screener_lead_id': json['screener_lead_id'],
        'user_id': json['user_id'],
        'role': LeadAssignmentRoleFromJSON(json['role']),
        'assigned_by_user_id': !exists(json, 'assigned_by_user_id') ? undefined : json['assigned_by_user_id'],
        'assigned_via': json['assigned_via'],
    };
}

export function LeadAssignmentToJSON(value?: LeadAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'screener_lead_id': value.screener_lead_id,
        'user_id': value.user_id,
        'role': LeadAssignmentRoleToJSON(value.role),
        'assigned_by_user_id': value.assigned_by_user_id,
        'assigned_via': value.assigned_via,
    };
}

